



































































































































import { Component, Vue } from 'vue-property-decorator';
import AuthModule from '@/store/modules/auth.module';
import { RouteName } from '@/utils/constants';
import { getModule } from 'vuex-module-decorators';

@Component({
})
export default class PrivacyPolicyView extends Vue {
  authStore = getModule(AuthModule, this.$store);

  goToHome() {
    if (this.authStore.isAuthenticated) {
      if (this.authStore.isIdirUser) {
        this.$router.push(`/${RouteName.Ministry}`);
      } else {
        this.$router.push(`/${RouteName.Main}`);
      }
    } else {
      this.$router.push('/');
    }
  }
}
